import { render, staticRenderFns } from "./SharingIndicators.vue?vue&type=template&id=57aace87&"
import script from "./SharingIndicators.vue?vue&type=script&lang=js&"
export * from "./SharingIndicators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports